import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authApi } from '../services/authApi';

const emptyUserInfo = {
  id: null,
  username: '',
  email: '',
  avatar: '👤',
  joinDate: '',
  level: '普通用户',
  parentInviteCode: '',
  myInviteCode: '',
  binanceUID: '',
  bitgetUID: '',
  wechat: '',
  okxUID: '',
  is_verified: false,
  user_type: '普通用户',
  premium_days: 0,
};

function mapApiUser(userData = {}) {
  return {
    id: userData.id || null,
    username: userData.nickname || userData.email || '',
    email: userData.email || '',
    avatar: '👤',
    joinDate: userData.joinDate || '',
    level: '普通用户',
    parentInviteCode: userData.parentInviteCode || '',
    myInviteCode: userData.inviteCode || '',
    binanceUID: userData.binanceUID || '',
    bitgetUID: userData.bitgetUID || '',
    wechat: userData.wechat || '',
    okxUID: userData.okxUID || '',
    is_verified: userData.isVerified === true,
    user_type: userData.userType || '普通用户',
    premium_days: typeof userData.premiumDays === 'number' ? userData.premiumDays : 0,
  };
}

const useUserStore = create(
  persist(
    (set, get) => ({
      token: null,
      isLoggedIn: false,
      userInfo: emptyUserInfo,

      login: (token, userData) => {
        set({
          token,
          isLoggedIn: true,
          userInfo: mapApiUser(userData),
        });
      },

      logout: () => {
        set({
          token: null,
          isLoggedIn: false,
          userInfo: emptyUserInfo,
        });
      },

      verifySession: async () => {
        const { token } = get();
        if (!token) return false;

        try {
          const data = await authApi.verifyToken(token);
          if (data.valid && data.user) {
            set({
              isLoggedIn: true,
              userInfo: mapApiUser(data.user),
            });
            return true;
          }
          get().logout();
          return false;
        } catch {
          get().logout();
          return false;
        }
      },

      updateUserInfo: (newInfo) => {
        set((state) => ({
          userInfo: {
            ...state.userInfo,
            ...newInfo,
            username: newInfo.nickname || state.userInfo.username,
          },
        }));
      },
    }),
    {
      name: 'user-storage',
      partialize: (state) => ({
        token: state.token,
        isLoggedIn: state.isLoggedIn,
        userInfo: state.userInfo,
      }),
      migrate: (persistedState) => {
        if (persistedState && persistedState.userInfo) {
          const token = persistedState.token || null;
          return {
            ...persistedState,
            token,
            isLoggedIn: Boolean(token && persistedState.isLoggedIn),
            userInfo: {
              ...emptyUserInfo,
              ...persistedState.userInfo,
              is_verified: persistedState.userInfo.is_verified !== undefined
                ? persistedState.userInfo.is_verified : false,
              user_type: persistedState.userInfo.user_type || '普通用户',
              premium_days: persistedState.userInfo.premium_days || 0,
            },
          };
        }
        return persistedState;
      },
      version: 2,
    }
  )
);

export default useUserStore;
